<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <el-table
                        :data="dataSet"
                        ref="singleTable"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Floor" :label="$t('getapi[13303]')"
                                     width="80" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Name" :label="$t('getapi[13296]')"
                                     width="80" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Num" :label="$t('getapi[13304]')"
                                     width="80" sortablea align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip :label="$t('getapi[13100]')"
                                     width="100" align="center">
                        <template scope="scope">
                            <span @click="viewLocation(scope.row)" style="text-decoration:underline;color:blue">{{$t('getapi[13100]')}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <!--<table class="addtable">
                    <tr>
                        <td style="font-size: 16px">{{'会议室名称'}}</td>
                        <td style="font-size: 16px">{{dataDetail.Head.conf_room}}</td>
                    </tr>
                </table>-->
                <div class="containes">
                    <div style="margin-left: 20px;font-size: 16px;text-align: center">{{$t('getapi[13312]')}}:{{dataDetail.Head.conf_room}}</div>
                    <!-- 头部 -->
                    <div class="header">
                        <div class="headerleft">
                            <div class="tybox">
                                <div style="backgroundColor: #e14444;" class="selecttype"></div>
                                <div class="text">{{$t('getapi[13305]')}}</div>
                            </div>
                            <div class="tybox">
                                <div style="backgroundColor: #72bbff" class="selecttype"></div>
                                <div class="text">{{$t('getapi[13306]')}}</div>
                            </div>
                            <!--<div class="tybox">
                                <div style="border: 1px solid #EEEEEE " class="selecttype"></div>
                                <div class="text">空闲</div>
                            </div>-->
                            <div class="tybox">
                                <div style="backgroundColor: #bbb" class="selecttype"></div>
                                <div class="text">{{$t('getapi[13307]')}}</div>
                            </div>
                        </div>
                        <div class="headerright">
                            <div>
                                <i class="el-icon-arrow-left" @click="backFn"></i>
                            </div>
                            <div>{{date[0]}}</div>
                            <div>
                                <i @click="nextFn" class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                    <!-- 日历部分 -->
                    <div>
                        <span style="margin-left:15px;margin-bottom: 5px;">提示：点击星期选取(或取消)当天所有可预约日期</span>
                    </div>
                    <div class="calendar">
                        <div class="calendarleft">
                            <div class="ctop"></div>
                            <div class="cbottom">
                                <!-- 时间 -->
                                <div v-for="(item, index) in timeList" :key="index" class="week">
                                    <div style="fontSize:14px;">{{ item }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="calendarright">
                            <div class="crtop">
                                <div v-for="(item, index) in date" :key="index" class="rdate" @click="selectAllDay(item)">
                                    <div style="fontSize:12px;">{{ item + weekArr[index] }}</div>
                                </div>
                            </div>
                            <div class="crbottom">
                                <!-- 日历内容 -->
                                <template v-for="(item, index) in rili">
                                    <!--<div :key="index" @click="selectcalendar(item)" :class="{box:true,selecolor:seleArr.findIndex(ite => ite===item)>-1}"></div>-->
                                    <div :key="index" @click="selectcalendar(item)" :class="{box:true,disable:item.disable,abooked:item.abooked,isActive:item.isActive}"></div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <el-dialog v-dialogDrag :visible.sync="showMeetingRoomLocation" width="900px" height="500px" :close-on-click-modal="false">
            <div>
                <div class="img_bg">
                    <img src="../../../assets/images/floor_1A.png" class="img" v-if="floor==='MF'">
                    <img src="../../../assets/images/floor_2.png" class="img" v-if="floor==='F2'">
                    <img src="../../../assets/images/floor_3.png" class="img" v-if="floor==='F3'">
                </div>
                <div class="canvas_bg">
                    <canvas id="myCanvas" class="canvas"></canvas>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[878]')" :visible.sync="showCreate" width="40%">
            <table class="addtable">
                <tr>
                    <td>
                        <span>{{$t('getapi[13294]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.Head.conf_room" type="text"></el-input>
                    </td>
                    <td>
                        <!--<span>{{$t('getapi[13945]')}}</span>-->
                    </td>
                    <td>
                        <!--<el-input v-model="dataDetail.Head.conf_date" type="text"></el-input>-->
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[13298]')}}</span>
                    </td>
                    <td colspan="3">
                        <el-input v-model="dataDetail.Head.conf_theme" type="text"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6339]')}}</span>
                    </td>
                    <td>
                        <el-date-picker v-model="dataDetail.Head.start_time" type="datetime"></el-date-picker>
                    </td>
                    <td>
                        <span>{{$t('getapi[4057]')}}</span>
                    </td>
                    <td>
                        <el-date-picker v-model="dataDetail.Head.show_end_time" type="datetime"></el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[13299]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.Head.appt_person" type="text"></el-input>
                    </td>
                    <td>
                        <span>{{$t('getapi[1202]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.Head.appt_tel" type="text"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4126]')}}</span>
                    </td>
                    <td>
                        <el-date-picker v-model="dataDetail.Head.create_time" type="date"></el-date-picker>
                    </td>
                    <td>
                        <span>{{$t('getapi[143]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.Head.remark" type="text"></el-input>
                    </td>
                </tr>
            </table>
            <div class="btnnowrap">
                <el-button type="primary" size="mini" @click="selectemployee">{{ $t('getapi[438]') }}</el-button>
                <el-button type="primary" size="mini" @click="delbatch" :disabled="selectData.length == 0">{{
                    $t('getapi[1522]') }}
                </el-button>
            </div>
            <el-table :data="dataDetail.Lists" height="500" size="mini" border
                      style="width: 100%; margin-top:2px" @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Person" :label="$t('getapi[13300]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="userID" :label="$t('getapi[13301]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="loginName" :label="$t('getapi[12385]')" width="100"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="showCreate = false" size="mini">{{$t('getapi[6]')}}</el-button>
                <el-button type="primary" @click="save" size="mini">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="employee"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    export default {
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data () {
            return {
                date: [],
                timeList: [
                    "07:00",
                    "07:30",
                    "08:00",
                    "08:30",
                    "09:00",
                    "09:30",
                    "10:00",
                    "10:30",
                    "11:00",
                    "11:30",
                    "12:00",
                    "12:30",
                    "13:00",
                    "13:30",
                    "14:00",
                    "14:30",
                    "15:00",
                    "15:30",
                    "16:00",
                    "16:30",
                    "17:00",
                    "17:30",
                    "18:00",
                    "18:30",
                ],
                weekArr: [],
                rili: [],
                seleArr: [],
                hasSelectArr:[],
                x:1,
                dataDetail:{
                    Head:{unnum: '',
                        conf_room: '',
                        conf_date: '',
                        conf_theme: '',
                        conf_content: '',
                        start_time: '',
                        end_time: '',
                        show_end_time: '',
                        conf_num: 0,
                        conf_device: '',
                        status: 0,
                        appt_tel: '',
                        appt_percode: '',
                        appt_person: '',
                        appt_time: '',
                        audit_person: '',
                        audit_time: '',
                        audit_opinion: '',
                        remark: '',
                        modify_time: '',
                        create_time: '',
                        datearr:[],},
                    Lists:[],
                },
                UserInfo:{},
                userData: [], // 用户信息
                dataSet:[],
                showMeetingRoomLocation:false,//是否展示会议室名称
                markers: [],
                canvas: '',
                ctx: '',
                showCreate:false,
                code:'',
                selectData:[],
                floor:'',
            }
        },
        created () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.dataDetail.Head.conf_date = this.getTime();
            that.dataDetail.Head.status=0;
            that.dataDetail.Head.appt_percode=that.userData.Login_Code;
            that.dataDetail.Head.appt_person=that.userData.username
        },
        mounted() {
            let that = this
            that.$limits.dragControllerDiv1();
            that.authority();
            that.getView()
            this.getDate();
            this.Rendering();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[108]"),this.$t("getapi[16]"));
            },
            authority(){
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.conf_room)) {
                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            selectemployee(type) {
                let that = this;
                that.$refs.employee.clearInput(true);
            },
            getemployee(data) {
                let that = this;
                if(that.dataDetail.Lists.length > 0){
                    data = data.filter(item => {
                        return that.dataDetail.Lists.every(item2 => {
                            return item2.userID != item.code
                        })
                    })
                }
                for (let i = 0; i < data.length; i++) {
                    that.dataDetail.Lists = [
                        ...that.dataDetail.Lists,
                        {
                            UnNum: '',
                            Person: data[i].name,
                            userID: data[i].code,
                            loginName: data[i].loginname,
                        }
                    ];
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].loginName);
                }
            },
            delbatch() {
                let that = this;
                let arr = that.dataDetail.Lists.filter(item => {
                    return that.selectData.every(item2 => {
                        return item.loginName != item2;
                    });
                });
                that.dataDetail.Lists = arr;
            },
            search(){
                let that = this
                that.getView()
            },
            reflash(){
                let that = this
                that.getView()
            },
            getView(){
                let that = this
                let parm = {}
                that.$http.urlpost('/Conf/View/GetConfRoom', parm, function (res) {
                    if (res.Success == 1) {
                        let arrays = res.DataContent.F1;
                        let arraysM = res.DataContent.MF;
                        let arrays2 = res.DataContent.F2;
                        let arrays3 = res.DataContent.F3;
                        that.dataSet = []
                        for(let i = 0;i<arrays.length;i++){
                            that.dataSet = [...that.dataSet,{
                                Floor:'F1',
                                Name:arrays[i].Name,
                                Num:arrays[i].Num
                            }]
                        }
                        for(let i = 0;i<arraysM.length;i++){
                            that.dataSet = [...that.dataSet,{
                                Floor:'MF',
                                Name:arraysM[i].Name,
                                Num:arraysM[i].Num
                            }]
                        }
                        for(let i = 0;i<arrays2.length;i++){
                            that.dataSet = [...that.dataSet,{
                                Floor:'F2',
                                Name:arrays2[i].Name,
                                Num:arrays2[i].Num
                            }]
                        }
                        for(let i = 0;i<arrays3.length;i++){
                            that.dataSet = [...that.dataSet,{
                                Floor:'F3',
                                Name:arrays3[i].Name,
                                Num:arrays3[i].Num
                            }]
                        }
                    }
                });
            },
            editInfo(row){
                let that = this
                that.dataDetail.Head.conf_room = row.Name
                that.code = row.Name
                that.getDetail(that.code)
            },
            getDetail(code){
                let that = this
                let parm = {
                    unnum: '',
                    conf_room:code,
                }
                that.$http.urlpost('/Conf/View/ConfHYTimes', parm, res => {
                    if (res.Success == 1) {
                        that.hasSelectArr = []
                        let day1 = that.getTime()
                        let day2 = that.getNextDate(day1,1)
                        let day3 = that.getNextDate(day1,2)
                        let day4 = that.getNextDate(day1,3)
                        let day5 = that.getNextDate(day1,4)
                        let day6 = that.getNextDate(day1,5)
                        let day7 = that.getNextDate(day1,6)
                        if(res.DataContent.datelist1 != ''){
                            let arr = res.DataContent.datelist1.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day1,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist2 != ''){
                            let arr = res.DataContent.datelist2.split(',')
                            console.log(arr)
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day2,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist3 != ''){
                            let arr = res.DataContent.datelist3.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day3,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist4 != ''){
                            let arr = res.DataContent.datelist4.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day4,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist5 != ''){
                            let arr = res.DataContent.datelist5.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day5,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist6 != ''){
                            let arr = res.DataContent.datelist6.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day6,"time":"18:30"}]
                                }
                            }
                        }
                        if(res.DataContent.datelist7 != ''){
                            let arr = res.DataContent.datelist7.split(',')
                            for(let i=0;i<arr.length;i++){
                                if(arr[i] == 1){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"07:00"}]
                                }
                                if(arr[i] == 2){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"07:30"}]
                                }
                                if(arr[i] == 3){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"08:00"}]
                                }
                                if(arr[i] == 4){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"08:30"}]
                                }
                                if(arr[i] == 5){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"09:00"}]
                                }
                                if(arr[i] == 6){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"09:30"}]
                                }
                                if(arr[i] == 7){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"10:00"}]
                                }
                                if(arr[i] == 8){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"10:30"}]
                                }
                                if(arr[i] == 9){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"11:00"}]
                                }
                                if(arr[i] == 10){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"11:30"}]
                                }
                                if(arr[i] == 11){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"12:00"}]
                                }
                                if(arr[i] == 12){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"12:30"}]
                                }
                                if(arr[i] == 13){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"13:00"}]
                                }
                                if(arr[i] == 14){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"13:30"}]
                                }
                                if(arr[i] == 15){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"14:00"}]
                                }
                                if(arr[i] == 16){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"14:30"}]
                                }
                                if(arr[i] == 17){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"15:00"}]
                                }
                                if(arr[i] == 18){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"15:30"}]
                                }
                                if(arr[i] == 19){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"16:00"}]
                                }
                                if(arr[i] == 20){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"16:30"}]
                                }
                                if(arr[i] == 21){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"17:00"}]
                                }
                                if(arr[i] == 22){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"17:30"}]
                                }
                                if(arr[i] == 23){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"18:00"}]
                                }
                                if(arr[i] == 24){
                                    that.hasSelectArr = [...that.hasSelectArr,{"date":day7,"time":"18:30"}]
                                }
                            }
                        }
                        that.Rendering();
                        that.authority()
                    }
                });
            },
            getDateInterval(arr) {
                let max = arr[0];
                let min = arr[0];
                arr.forEach((item, index) => {
                    let beginDate = item;
                    let endDate = item;
                    if (new Date(endDate) > new Date(max)) {
                        max = endDate;
                    }
                    if (new Date(beginDate) < new Date(min)) {
                        min = beginDate;
                    }
                });
                return {
                    endDate: max,
                    beginDate: min,
                };
            },
            add(){
                let that = this
                if(that.seleArr.length == 0){
                    that.$message.warning(that.$t('getapi[13302]'))
                    return
                } else {
                    that.showCreate = true
                    let arr = []
                    for(let i =0;i<that.seleArr.length;i++){
                        arr = [...arr,that.seleArr[i].date + ' ' + that.seleArr[i].time]
                    }
                    that.dataDetail.Head.start_time = that.getDateInterval(arr).beginDate
                    that.dataDetail.Head.end_time = that.getDateInterval(arr).endDate.replace(' ', 'T')
                    let endtime = that.dataDetail.Head.end_time
                    var sdate1 = new Date(endtime);
                    sdate1.setMinutes (sdate1.getMinutes () + 30);
                    let year =sdate1.getFullYear();
                    let month = sdate1.getMonth() + 1;
                    let day = sdate1.getDate();
                    let hh = sdate1.getHours() < 10 ? '0' + sdate1.getHours() : sdate1.getHours();
                    let mm = sdate1.getMinutes() < 10 ? '0' + sdate1.getMinutes() : sdate1.getMinutes();
                    let ss = sdate1.getSeconds() < 10 ? '0' + sdate1.getSeconds() : sdate1.getSeconds();
                    month = month > 9 ? month : '0' + month;
                    day = day > 9 ? day : '0' + day;
                    that.dataDetail.Head.show_end_time= `${sdate1.getFullYear()}-${String(sdate1.getMonth() + 1).padStart(2, '0')}-${String(sdate1.getDate()).padStart(2, '0')} ${String(sdate1.getHours()).padStart(2, '0')}:${String(sdate1.getMinutes()).padStart(2, '0')}`;
                }
            },
            save(){
                let that = this
                let str1 = ''
                let str2 = ''
                let str3 = ''
                let str4 = ''
                let str5 = ''
                let str6 = ''
                let str7 = ''
                let day1 = that.getTime()
                let day2 = that.getNextDate(day1,1)
                let day3 = that.getNextDate(day1,2)
                let day4 = that.getNextDate(day1,3)
                let day5 = that.getNextDate(day1,4)
                let day6 = that.getNextDate(day1,5)
                let day7 = that.getNextDate(day1,6)
                for(let i=0;i<that.seleArr.length;i++){
                    if(that.seleArr[i].date == day1){
                        if(that.seleArr[i].time == '07:00'){
                            str1 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str1 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str1 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str1 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str1 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str1 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str1 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str1 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str1 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str1 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str1 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str1 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str1 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str1 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str1 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str1 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str1 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str1 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str1 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str1 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str1 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str1 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str1 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str1 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day2){
                        if(that.seleArr[i].time == '07:00'){
                            str2 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str2 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str2 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str2 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str2 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str2 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str2 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str2 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str2 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str2 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str2 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str2 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str2 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str2 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str2 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str2 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str2 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str2 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str2 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str2 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str2 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str2 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str2 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str2 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day3){
                        if(that.seleArr[i].time == '07:00'){
                            str3 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str3 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str3 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str3 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str3 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str3 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str3 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str3 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str3 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str3 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str3 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str3 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str3 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str3 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str3 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str3 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str3 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str3 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str3 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str3 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str3 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str3 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str3 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str3 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day4){
                        if(that.seleArr[i].time == '07:00'){
                            str4 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str4 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str4 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str4 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str4 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str4 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str4 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str4 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str4 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str4 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str4 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str4 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str4 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str4 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str4 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str4 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str4 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str4 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str4 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str4 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str4 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str4 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str4 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str4 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day5){
                        if(that.seleArr[i].time == '07:00'){
                            str5 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str5 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str5 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str5 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str5 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str5 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str5 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str5 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str5 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str5 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str5 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str5 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str5 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str5 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str5 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str5 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str5 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str5 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str5 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str5 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str5 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str5 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str5 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str5 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day6){
                        if(that.seleArr[i].time == '07:00'){
                            str6 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str6 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str6 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str6 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str6 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str6 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str6 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str6 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str6 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str6 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str6 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str6 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str6 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str6 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str6 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str6 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str6 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str6 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str6 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str6 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str6 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str6 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str6 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str6 += '24,'
                        }
                    }
                    if(that.seleArr[i].date == day7){
                        if(that.seleArr[i].time == '07:00'){
                            str7 += '1,'
                        }
                        if(that.seleArr[i].time == '07:30'){
                            str7 += '2,'
                        }
                        if(that.seleArr[i].time == '08:00'){
                            str7 += '3,'
                        }
                        if(that.seleArr[i].time == '08:30'){
                            str7 += '4,'
                        }
                        if(that.seleArr[i].time == '09:00'){
                            str7 += '5,'
                        }
                        if(that.seleArr[i].time == '09:30'){
                            str7 += '6,'
                        }
                        if(that.seleArr[i].time == '10:00'){
                            str7 += '7,'
                        }
                        if(that.seleArr[i].time == '10:30'){
                            str7 += '8,'
                        }
                        if(that.seleArr[i].time == '11:00'){
                            str7 += '9,'
                        }
                        if(that.seleArr[i].time == '11:30'){
                            str7 += '10,'
                        }
                        if(that.seleArr[i].time == '12:00'){
                            str7 += '11,'
                        }
                        if(that.seleArr[i].time == '12:30'){
                            str7 += '12,'
                        }
                        if(that.seleArr[i].time == '13:00'){
                            str7 += '13,'
                        }
                        if(that.seleArr[i].time == '13:30'){
                            str7 += '14,'
                        }
                        if(that.seleArr[i].time == '14:00'){
                            str7 += '15,'
                        }
                        if(that.seleArr[i].time == '14:30'){
                            str7 += '16,'
                        }
                        if(that.seleArr[i].time == '15:00'){
                            str7 += '17,'
                        }
                        if(that.seleArr[i].time == '15:30'){
                            str7 += '18,'
                        }
                        if(that.seleArr[i].time == '16:00'){
                            str7 += '19,'
                        }
                        if(that.seleArr[i].time == '16:30'){
                            str7 += '20,'
                        }
                        if(that.seleArr[i].time == '17:00'){
                            str7 += '21,'
                        }
                        if(that.seleArr[i].time == '17:30'){
                            str7 += '22,'
                        }
                        if(that.seleArr[i].time == '18:00'){
                            str7 += '23,'
                        }
                        if(that.seleArr[i].time == '18:30'){
                            str7 += '24,'
                        }
                    }
                }
                str1 = str1.substring(0,str1.length -1)
                str2 = str2.substring(0,str2.length -1)
                str3 = str3.substring(0,str3.length -1)
                str4 = str4.substring(0,str4.length -1)
                str5 = str5.substring(0,str5.length -1)
                str6 = str6.substring(0,str6.length -1)
                str7 = str7.substring(0,str7.length -1)
                let parm = {
                    Head:{
                        unnum: that.dataDetail.Head.unnum,
                        conf_room: that.dataDetail.Head.conf_room,
                        conf_theme: that.dataDetail.Head.conf_theme,
                        start_time: that.dataDetail.Head.start_time,
                        end_time: that.dataDetail.Head.show_end_time,
                        appt_tel: that.dataDetail.Head.appt_tel,
                        appt_person: that.dataDetail.Head.appt_person,
                        conf_date: that.dataDetail.Head.conf_date,
                        datelist1:str1,
                        datelist2:str2,
                        datelist3:str3,
                        datelist4:str4,
                        datelist5:str5,
                        datelist6:str6,
                        datelist7:str7,
                    },
                    Lists: that.dataDetail.Lists
                };
                that.$http.urlpost('/Conf/View/AddConfWithPerson', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.code)
                        that.$message.success(that.$t('getapi[284]'))
                        that.showCreate = false
                    }
                });
            },
            getTime(){
                const date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
                let mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
                let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                month = month > 9 ? month : '0' + month;
                day = day > 9 ? day : '0' + day;
                return `${year}-${month}-${day}`;
            },
            getNextDate(date, day) {
                var dd = new Date(date);
                dd.setDate(dd.getDate() + day);
                var y = dd.getFullYear();
                var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
                var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
                return y + "-" + m + "-" + d;
            },
            // 获取日期
            getDate() {
                var today = new Date();
                var dateArr = [];
                for (var i = 0; i < 7*this.x; i++) {
                    var newDate = new Date(today.getTime() + i * 1000 * 60 * 60 * 24);
                    var year = newDate.getFullYear();
                    var month =
                        parseInt(newDate.getMonth()) + 1 > 9
                            ? parseInt(newDate.getMonth()) + 1
                            : "0" + (parseInt(newDate.getMonth()) + 1);
                    var day =
                        newDate.getDate() > 9 ? newDate.getDate() : "0" + newDate.getDate();
                    var fullDate = `${year}-${month}-${day}`;
                    dateArr.push(fullDate);
                }
                this.date = dateArr.slice(7*(this.x-1),dateArr.length);
                console.log('this.date' + this.date)
                // console.log("原", dateArr);
                // console.log("1", dateArr.slice(10*(this.x-1),dateArr.length).reverse());

                function isNull(object) {
                    if (object == null || typeof object == "undefined") {
                        return true;
                    }
                    return false;
                }
                // 获取 星期几
                function getWeek(dateString) {
                    var date;
                    if (isNull(dateString)) {
                        date = new Date();
                    } else {
                        var dateArray = dateString.split("-");
                        date = new Date(
                            dateArray[0],
                            parseInt(dateArray[1] - 1),
                            dateArray[2]
                        );
                    }
                    var weeks = new Array("日", "一", "二", "三", "四", "五", "六");
                    return "星期" + weeks[date.getDay()];
                    // return "星期" + "日一二三四五六".charAt(date.getDay);
                }
                let arr = [];
                dateArr.forEach((it) => {
                    arr.push(getWeek(it));
                });
                this.weekArr = arr.slice(7*(this.x-1),arr.length);
                // console.log("2", arr.slice(10*(this.x-1),arr.length));
            },
            // 前几天的日期(x为负数的时候使用)
            backDate(){
                function isNull(object) {
                    if (object == null || typeof object == "undefined") {
                        return true;
                    }
                    return false;
                }
                // 获取 星期几
                function getWeek(dateString) {
                    var date;
                    if (isNull(dateString)) {
                        date = new Date();
                    } else {
                        var dateArray = dateString.split("-");
                        date = new Date(
                            dateArray[0],
                            parseInt(dateArray[1] - 1),
                            dateArray[2]
                        );
                    }
                    var weeks = new Array("日", "一", "二", "三", "四", "五", "六");
                    return "星期" + weeks[date.getDay()];
                    // return "星期" + "日一二三四五六".charAt(date.getDay);
                }
                var today = new Date();
                var dateArr = [];
                // let x = -2 //-1的效果喝1的效果一样 从-2 开始
                for (var i = 0; i > 7 * this.x; i--) {
                    var newDate = new Date(today.getTime() + i * 1000 * 60 * 60 * 24);
                    var year = newDate.getFullYear();
                    var month =
                        parseInt(newDate.getMonth()) + 1 > 9
                            ? parseInt(newDate.getMonth()) + 1
                            : "0" + (parseInt(newDate.getMonth()) + 1);
                    var day =
                        newDate.getDate() > 9 ? newDate.getDate() : "0" + newDate.getDate();
                    var fullDate = `${year}-${month}-${day}`;
                    dateArr.push(fullDate);
                    this.date=dateArr.slice(7*(this.x+1)*-1,dateArr.length)
                    // console.log("1.1", dateArr.slice(10*(this.x+1)*-1,dateArr.length));
                    // console.log('2.0',dateArr)
                    let arr = [];
                    dateArr.forEach((it) => {
                        arr.push(getWeek(it));
                    });
                    this.weekArr = arr.slice(7*(this.x+1)*-1,arr.length);
                    console.log("2.3", arr.slice(7*(this.x+1)*-1,arr.length));
                }
            },
            // 渲染
            Rendering() {
                let that = this
                that.rili = []
                that.timeList.forEach((item) => {
                    that.date.forEach((v) => {
                        let obj = { date: v, time: item , isActive: false,disable:false,abooked:false};
                        that.rili.push(obj);
                    });
                });
                that.rili.forEach((item, index) => {
                    if(item.date == that.currentTime().date && that.currentTime().time > item.time){
                        item.disable = true
                    }
                    for(let i=0;i<that.hasSelectArr.length;i++){
                        if(item.date == that.hasSelectArr[i].date && item.time == that.hasSelectArr[i].time){
                            item.abooked = true
                        }
                    }
                });
            },
            // 点击选择
            /*selectcalendar(ite) {
                console.log(ite)
                console.log(this.seleArr)
                let that = this
                if (ite.disable || ite.abooked) return
                ite.isActive = !ite.isActive
                this.seleArr = []
                for(let i=0;i<that.rili.length;i++){
                    if(that.rili[i].isActive){
                        this.seleArr.push(that.rili[i])
                    }
                }
            },*/
            selectcalendar(ite) {
                console.log(ite)
                let that = this
                if (ite.disable || ite.abooked) return

                // 获取当天的所有时间段
                const currentDayItems = that.rili.filter(item => item.date === ite.date)

                // 获取当天已选中的项
                const selectedItems = currentDayItems.filter(item => item.isActive)

                // 获取当前点击项的时间索引（按半小时为单位）
                const timeToIndex = (time) => {
                    const [hours, minutes] = time.split(':').map(Number)
                    return (hours - 7) * 2 + (minutes === 30 ? 1 : 0) // 从07:00开始，每半小时一个索引
                }

                const currentIndex = timeToIndex(ite.time)

                // 判断当前点击的是否是已选中的项
                const isSelected = selectedItems.some(item => item.time === ite.time)

                // 如果没有选中任何项，则直接激活当前项
                if (selectedItems.length === 0) {
                    ite.isActive = true
                }
                // 如果已经选中了项
                else {
                    // 获取所有选中项的时间索引，并排序
                    const selectedIndices = selectedItems.map(item => timeToIndex(item.time)).sort((a, b) => a - b)

                    // 找到最小和最大索引
                    const minIndex = selectedIndices[0]
                    const maxIndex = selectedIndices[selectedIndices.length - 1]

                    // 如果当前项是已选中的（取消模式）
                    if (isSelected) {
                        // 找到当前项在选中项中的位置
                        const currentPos = selectedIndices.indexOf(currentIndex)

                        // 取消从当前节点之后的所有时间点
                        // 包括当前节点和之后的所有已选中节点之间的所有时间
                        const cancelStart = currentIndex
                        const cancelEnd = maxIndex
                        // 执行取消操作
                        for (let i = 0; i < currentDayItems.length; i++) {
                            const item = currentDayItems[i]
                            const itemIndex = timeToIndex(item.time)

                            if (itemIndex >= cancelStart && itemIndex <= cancelEnd) {
                                if (!item.disable && !item.abooked) {
                                    item.isActive = false
                                    console.log('取消:', item.time)
                                }
                            }
                        }
                    }
                    // 如果当前项是未选中的（激活模式）
                    else {
                        // 确定要激活的范围
                        let selectStart, selectEnd

                        if (currentIndex < minIndex) {
                            // 点击在左边，激活从当前到最小索引
                            selectStart = currentIndex
                            selectEnd = minIndex
                        } else if (currentIndex > maxIndex) {
                            // 点击在右边，激活从最大索引到当前
                            selectStart = maxIndex
                            selectEnd = currentIndex
                        } else {
                            // 点击在中间，激活从上一个选中项到下一个选中项之间的所有
                            // 找到当前索引前后的选中项
                            const leftSelected = Math.max(...selectedIndices.filter(idx => idx < currentIndex))
                            const rightSelected = Math.min(...selectedIndices.filter(idx => idx > currentIndex))
                            selectStart = leftSelected
                            selectEnd = rightSelected
                        }
                        // 检查区间内是否有不可选中的项
                        let hasDisableItem = false
                        for (let i = 0; i < currentDayItems.length; i++) {
                            const item = currentDayItems[i]
                            const itemIndex = timeToIndex(item.time)

                            if (itemIndex >= selectStart && itemIndex <= selectEnd) {
                                if (item.disable || item.abooked) {
                                    hasDisableItem = true
                                    break
                                }
                            }
                        }

                        // 如果区间内有不可选中的项，则操作无效
                        if (hasDisableItem) {
                            console.log('区间内存在不可选中的时间段，操作无效')
                            return
                        }

                        // 执行激活操作
                        for (let i = 0; i < currentDayItems.length; i++) {
                            const item = currentDayItems[i]
                            const itemIndex = timeToIndex(item.time)

                            if (itemIndex >= selectStart && itemIndex <= selectEnd) {
                                if (!item.disable && !item.abooked) {
                                    item.isActive = true
                                }
                            }
                        }
                    }
                }
                // 更新 seleArr（所有天的选中项）
                this.seleArr = []
                for(let i = 0; i < that.rili.length; i++){
                    if(that.rili[i].isActive){
                        this.seleArr.push(that.rili[i])
                    }
                }
            },
            //点击选择当天所有可预约日期
            selectAllDay(item){
                console.log(item)
                let that = this
                let dayarr = []
                for(let i=0;i<that.rili.length;i++){
                    if(!(item.disable || item.abooked) && that.rili[i].date == item){
                        that.rili[i].isActive = !that.rili[i].isActive
                    }
                }
                this.seleArr = []
                for(let i=0;i<that.rili.length;i++){
                    if(that.rili[i].isActive){
                        this.seleArr.push(that.rili[i])
                    }
                }
            },
            nextFn(){
                this.x+=1
                if(this.x===-1){
                    this.x=1
                }
                this.seleArr=[]
                this.rili=[]
                this.weekArr=[]
                if(this.x>0){
                    this.getDate()
                }if (this.x<0){
                    this.backDate()
                }
                this.Rendering()
            },
            backFn(){
                if(this.x <= 1){
                    return false
                }
                this.x-=1
                if(this.x===0){
                    this.x=-2
                }
                this.seleArr=[]
                this.rili=[]
                this.weekArr=[]
                if(this.x>0){
                    this.getDate()
                }if (this.x<0){
                    this.backDate()
                }
                this.Rendering()
            },
            currentTime() {
                let that = this
                const myDate = new Date();
                const y = myDate.getFullYear()
                const m = myDate.getMonth() + 1;
                const d = myDate.getDate();
                const date = y + '-' + that.strFormat(m) + '-' + that.strFormat(d);

                const hour = myDate.getHours()
                const min = myDate.getMinutes()
                const secon = myDate.getSeconds()
                const time = that.strFormat(hour) + ':' + that.strFormat(min) + ':' + that.strFormat(secon);
                return {
                    date,
                    time
                }
            },
            strFormat(str) {
                return str < 10 ? `0${str}` : str
            },
            //查看会议室位置
            viewLocation(row){
                let that = this
                that.floor = row.Floor
                that.showMeetingRoomLocation = true
                setTimeout(() => {
                    that.init(row.Name)
                }, 500);
            },
            init(name){
                let that = this
                that.canvas = document.getElementById("myCanvas")
                that.ctx = that.canvas.getContext('2d')
                that.canvas.width = 800;
                that.canvas.height = 450;
                that.draw(name)
            },
            draw(name){
                let that = this
                // 清空画布
                that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);
                let x=0,y=0
                if(name == '培训室1'){
                    x=490,y=270
                } else if(name == '培训室2'){
                    x=420,y=270
                } else if(name == '创新'){
                    x=650,y=270
                } else if(name == '和谐'){
                    x=550,y=255
                } else if(name == '尊重'){
                    x=550,y=295
                } else if(name == '沟通'){
                    x=535,y=370
                } else if(name == '精益'){
                    x=410,y=270
                } else if(name == '开拓'){
                    x=445,y=300
                } else if(name == '智造'){
                    x=500,y=270
                } else if(name == '合作'){
                    x=565,y=360
                } else if(name == '协同'){
                    x=535,y=340
                } else if(name == '匠心'){
                    x=285,y=360
                } else if(name == '卓越'){
                    x=255,y=360
                } else if(name == '接待厅'){
                    x=105,y=180
                } else if(name == '会议厅'){
                    x=175,y=180
                } else if(name == 'VIP室'){
                    x=545,y=180
                } else if(name == '智能会议室'){
                    x=330,y=265
                } else if(name == 'VIP1'){
                    x=410,y=265
                } else if(name == 'VIP2'){
                    x=440,y=265
                } else if(name == 'VIP3'){
                    x=470,y=265
                } else if(name == 'VIP4'){
                    x=500,y=265
                }
                let marker = { x: x, y: y, text: name, color: '#db534e', size: 'medium' }
                that.drawWaterDrop(marker);
            },
            drawWaterDrop(marker) {
                const radius = this.getRadius(marker.size);
                const x = Number(marker.x);
                const y = Number(marker.y);

                this.ctx.beginPath();

                // 绘制圆形顶部
                this.ctx.arc(x, y - radius * 0.5, radius, 0, Math.PI * 2);

                // 绘制三角形底部
                this.ctx.moveTo(x - radius/2, y + 8);
                this.ctx.lineTo(x, y + radius * 1.5 + 8);
                this.ctx.lineTo(x + radius/2, y + 8);

                this.ctx.closePath();

                // 填充颜色
                try {
                    const gradient = this.ctx.createRadialGradient(x, y, 0, x, y, radius * 1.5);
                    gradient.addColorStop(0, this.lightenColor(marker.color, 30));
                    gradient.addColorStop(1, marker.color);
                    this.ctx.fillStyle = gradient;
                } catch (e) {
                    this.ctx.fillStyle = marker.color;
                }
                this.ctx.fill();

                // 边框
                this.ctx.lineWidth = 2;
                this.ctx.strokeStyle = 'rgba(0, 0, 0, 0)'; // 完全透明
                this.ctx.stroke();

                // 高光
                this.ctx.beginPath();
                this.ctx.arc(x - radius/3, y - radius/3, radius/3, 0, Math.PI * 2);
                this.ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
                this.ctx.fill();

                this.ctx.restore();

                // 文字
                this.ctx.fillStyle = 'white';
                this.ctx.font = `bold ${this.getFontSize(marker.size)} Arial`;
                this.ctx.textAlign = 'center';
                this.ctx.textBaseline = 'middle';
                this.ctx.fillText(marker.text, x, y-8);
            },
            getRadius(size) {
                switch(size) {
                    case 'small': return 15;
                    case 'large': return 25;
                    default: return 20;
                }
            },
            getFontSize(size) {
                switch(size) {
                    case 'small': return '12px';
                    case 'large': return '16px';
                    default: return '14px';
                }
            },
            lightenColor(color, percent) {
                const num = parseInt(color.slice(1), 16);
                const amt = Math.round(2.55 * percent);
                const R = Math.min(255, (num >> 16) + amt);
                const G = Math.min(255, (num >> 8 & 0x00FF) + amt);
                const B = Math.min(255, (num & 0x0000FF) + amt);
                return "#" + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
            },
            darkenColor(color, percent) {
                const num = parseInt(color.slice(1), 16);
                const amt = Math.round(2.55 * percent);
                const R = Math.max(0, (num >> 16) - amt);
                const G = Math.max(0, (num >> 8 & 0x00FF) - amt);
                const B = Math.max(0, (num & 0x0000FF) - amt);
                return "#" + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
            }
        }
    }
</script>

<style lang="scss" scope="scope">
    .addtable {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .containes{
        padding: 20px 0 !important;
    }
    .header {
        display: flex;
        align-items: center;
        height: 10%;
        //border: 1px solid #EEEEEE ;
        padding: 20px;
        .headerleft {
            width: 40%;
            height: 100%;
            display: flex;
            align-items: center;
            .tybox {
                display: flex;
                align-items: center;
                font-size: 16px;
                height: 30px;
                margin-left: 15px;
                // width:100px;
                .selecttype {
                    height: 16px;
                    width: 30px;
                    // background-color: skyblue;
                }
                .text {
                    margin-left: 10px;
                }
            }
        }
        .headerright {
            display: flex;
        }
    }
    .calendar {
        display: grid;
        grid-template-columns: 1fr 9fr;
        height: 90%;
        .calendarleft {
            height: 100%;
            .ctop {
                height: 10%;
                min-height: 20px;
                border: 1px solid #EEEEEE ;
            }
            .cbottom {
                height: 90%;
                display: grid;
                justify-items: stretch;
                grid-template-rows: repeat(24, 1fr);
                .week {
                    display: flex;
                    min-height: 20px;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #EEEEEE ;
                }
            }
        }
        .calendarright {
            height: 100%;
            // background-color: red;
            .crtop {
                display: grid;
                grid-template-columns: repeat(7, 1fr);
                height: 10%;
                min-height: 20px;
                .rdate {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    border: 1px solid #EEEEEE ;
                    text-align: center;
                }
            }
            .crbottom {
                height: 90%;
                display: grid;
                grid-template: repeat(24, 1fr) / repeat(7, 1fr);
                .box {
                    min-height: 20px;
                    border: 1px solid #EEEEEE ;
                }
                .selecolor{
                    background-color: #72bbff;
                }
            }
            .isActive{
                background-color: #72bbff;
            }
            .abooked{
                background-color: #e14444;
            }
            .disable{
                background-color: #bbb;
            }
        }
    }

    .img_bg {
        width: 800px;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        postion:relative;
    }

    .img {
        width: 800px;
        height: auto;
    }

    .canvas_bg {
        width: 800px;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
</style>